var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ringtone Mute Hide (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.6529 22.1573C8.02093 21.5086 7.1803 20.4177 7.0376 18.6664C7.0376 15.1858 9.12492 15.4012 9.12492 11.1305C9.12492 7.79389 12.1605 4.00195 16.8165 4.00195C20.0688 4.00195 22.5166 5.84927 23.7166 8.09357",
    stroke: "#D32F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M24.6256 12.7168C25.0641 15.4152 26.5975 15.6889 26.5975 18.6648C26.3095 22.157 23.3089 23.0211 16.8173 23.0211C15.8768 23.0211 15.0141 23.0055 14.2241 22.9613",
    stroke: "#D32F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M14.061 26.6309C14.733 27.4702 15.741 27.9995 16.8566 27.9995C17.9853 27.9995 18.9933 27.4702 19.6653 26.6309",
    stroke: "#D32F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.51562 25.2997L26.8193 4.99609",
    stroke: "#D32F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBlocked);
export default __webpack_public_path__ + "static/media/notificationBlocked.a4a591859e7d14428841ba73b93b911a.svg";
export { ForwardRef as ReactComponent };